// 🔒 PANTALLA-ESPERA-2026-10-17 — pantalla completa con fotos/anuncios y
// "Toca para empezar". Un toque la cierra y queda el login con el PIN de siempre.
import { useEffect, useState } from 'react';

export default function PantallaEspera({ cfg, branding, apiBase, onDespertar }) {
  const fotos = cfg.modo === 'fija' ? cfg.imagenes.slice(0, 1) : cfg.imagenes;
  const [actual, setActual] = useState(0);

  useEffect(() => {
    if (fotos.length < 2) return undefined;
    const t = setInterval(() => setActual((n) => (n + 1) % fotos.length), cfg.segundos * 1000);
    return () => clearInterval(t);
  }, [fotos.length, cfg.segundos]);

  return (
    <button
      type="button"
      onClick={onDespertar}
      aria-label={cfg.texto}
      // 🔒 PANTALLA-ESPERA-2 — el tema claro (theme-minimalist.css L587) vuelve oscuro
      // el texto blanco de Tailwind; un botón con color blanco en línea sí se respeta (L1250-1262).
      style={{ color: '#ffffff' }}
      className="fixed inset-0 z-50 w-full h-full bg-black flex items-center justify-center overflow-hidden"
      data-testid="pantalla-espera"
    >
      {fotos.length > 0 ? fotos.map((u, i) => (
        <div
          key={u}
          className="absolute inset-0 overflow-hidden transition-opacity duration-700"
          style={{ opacity: i === actual % fotos.length ? 1 : 0 }}
        >
          {cfg.ajuste === 'completa' && (
            <img src={`${apiBase}${u}`} alt="" aria-hidden="true"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ filter: 'blur(24px) brightness(0.6)', transform: 'scale(1.1)' }} />
          )}
          <img
            src={`${apiBase}${u}`}
            alt=""
            className={`absolute inset-0 w-full h-full ${cfg.ajuste === 'completa' ? 'object-contain' : 'object-cover'}`}
          />
        </div>
      )) : branding.logo_url ? (
        <img src={`${apiBase}${branding.logo_url}`} alt="" className="w-48 h-48 object-contain" />
      ) : (
        <span className="font-oswald text-5xl font-bold">{branding.restaurant_name || 'POS'}</span>
      )}
      <span className="absolute bottom-10 left-1/2 -translate-x-1/2 px-10 py-4 rounded-full bg-black/70 font-oswald text-2xl md:text-3xl font-bold tracking-wide whitespace-nowrap">
        {cfg.texto}
      </span>
    </button>
  );
}
